import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import locale from '../locale/Localization';
import HelpIcon from './HelpIcon';

/**
 * LoginDialog for Yubikey authentication.
 */
export default class LoginDialog extends Component {
  // eslint-disable-next-line require-jsdoc
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      userName: ''
    };
    this.handleLogin = props.handleLogin;
  }

  /**
   * Handles the enter key press to login.
   *
   * @param {Event} event - The key press event.
   */
  handleKeyPress = (event: Event) => {
    if (this.enabledLogin() && event.key === 'Enter') {
      this.props.handleLogin(this.state.userName);
    }
  };

  /**
   * Check if the login can be enabled.
   *
   * @return {boolean} - Returns the boolean value.
   */
  enabledLogin = () => {
    return this.state.userName && this.state.userName.length === 7;
  };

  /**
   * React render function.
   * @return {string} - The component contents.
   */
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        aria-labelledby='form-dialog-title'
      >
        <DialogTitle id='login-dialog-title'>
          {locale.loginDialogTitle}
          <HelpIcon style={{float: 'right', marginTop: -8}} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{locale.loginDialogText}</DialogContentText>
          <TextField
            autoFocus
            margin='dense'
            id='name'
            label={locale.loginDialogUserName}
            type='text'
            fullWidth
            value={this.state.userName}
            onChange={(event) => {
              this.setState({
                userName: event.target.value
              });
            }}
            onKeyUp={(event) => this.handleKeyPress(event)}
            inputProps={{maxLength: 7}}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.props.handleClose}
            color='primary'
            variant='outlined'
          >
            {locale.cancelButton}
          </Button>
          <Button
            disabled={!this.enabledLogin()}
            onClick={() => this.props.handleLogin(this.state.userName)}
            color='primary'
            variant='contained'
          >
            {locale.loginDialogLogin}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

LoginDialog.propTypes = {
  handleLogin: PropTypes.func.isRequired,
  handleOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};
